module.exports = __webpack_public_path__ + "img/pos3-bg.834f5eb9.jpg";